import {
  VEHICLE_LIST,
  VEHICLE_FILTER,
  VEHICLE_CREATE,
  VEHICLE_UPDATE,
  VEHICLE_UPDATE_SUCCESS,
  VEHICLE_CREATE_SUCCESS,
  VEHICLE_LIST_SUCCESS,
  VEHICLE_REQUEST_FAILED,
} from "store/vehicles/actionTypes";

export const vehicleList = () => {
  return {
    type: VEHICLE_LIST,
    payload: {},
  };
};

export const vehicleCreate = (vehicle) => {
  return {
    type: VEHICLE_CREATE,
    payload: vehicle,
  };
};

export const vehicleFilter = (changeUrl) => {
  return {
    type: VEHICLE_FILTER,
    payload: { changeUrl },
  };
};

export const vehicleUpdate = (id, data) => {
  return {
    type: VEHICLE_UPDATE,
    payload: { id, data },
  };
};

export const vehicleListSuccess = (vehicles) => {
  return {
    type: VEHICLE_LIST_SUCCESS,
    payload: vehicles,
  };
};

export const vehicleCreateSuccess = (vehicleCreated) => {
  return {
    type: VEHICLE_CREATE_SUCCESS,
    payload: vehicleCreated,
  };
};

export const vehicleUpdateSuccess = (vehicle) => {
  return {
    type: VEHICLE_UPDATE_SUCCESS,
    payload: vehicle,
  };
};

export const vehicleRequestFailed = (error) => {
  return {
    type: VEHICLE_REQUEST_FAILED,
    payload: error,
  };
};
